import { render, staticRenderFns } from "./course_view.vue?vue&type=template&id=f612220c&scoped=true&"
import script from "./course_view.vue?vue&type=script&lang=js&"
export * from "./course_view.vue?vue&type=script&lang=js&"
import style0 from "./course_view.vue?vue&type=style&index=0&id=f612220c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612220c",
  null
  
)

export default component.exports